<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f"><a id="page_iii"></a>A note on the author</h2>
<p class="para">Alan Warner was born in 1964 in Oban. His 1995 debut, <em>Morvern Callar</em>, is a contemporary classic. He has won the Somerset Maugham award and the James Tait Black Memorial Prize, was nominated for the Booker Prize and was picked as a Granta Best Young British Novelist. His other novels include <em>The Sopranos, These Demented Lands, The Deadman’s Pedal</em> and <em>Kitchenly 434</em>. He teaches creative writing at the University of Aberdeen.<a id="page_iv"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?46d38768